import { PlusOutlined } from "@ant-design/icons";
import {
	Button,
	Card,
	Col,
	Form,
	Input,
	Row,
	Select,
	Typography,
	Upload,
	Radio
} from "antd";
import { toast } from "react-toastify";

import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addProduct, addRunningSize } from "../../redux/actions/product/addProductAction";
import { loadAllProductBrand } from "../../redux/actions/productBrand/getProductBrandAction";
import { loadAllProductCategory } from "../../redux/actions/productCategory/getProductCategoryAction";
import { loadAllProductSubCategory } from "../../redux/actions/productSubCategory/getProductSubCategory";
import { loadAllCustomer } from "../../redux/actions/customer/getCustomerAction";
import { loadRunningSize } from "../../redux/actions/product/getAllProductAction";
import axios from "axios";
import UploadMany from "../Card/UploadMany";
import styles from "./AddProd.module.css";
import LayerSelectorBasic from "../Card/LayerSelectorBasic";
import LayerSelectorAdvance from "../Card/LayerSelectorAdvance";
import LayerTemplateSelector from "../Card/LayerTemplateSelector";
import PrintSelector from "../Card/PrintSelector";
import CoatingSelector from "../Card/CoatingSelector";
import data from '../../data/rawMaterialData'
import { buildLayersForPly } from '../../utils/layerUtils'

const AddRunningSize = () => {
	const {unitType, ply, castingType} = data
	
	const yesNo = ["Yes", "No"]
	
	const layerObj = {layerId: 0, layerType: "", materialType:"", gsm:"", bf:"", ff:""};
	
	const category = useSelector((state) => state.productCategories?.list);

	const subCategory = useSelector((state) => state.productSubCategories?.list);

	const customer = useSelector((state) => state.customers?.list);

	const runningSizes = useSelector((state) => state.products?.list);

	const dispatch = useDispatch();
	//useEffect for loading category list from redux
	useEffect(() => {
		dispatch(loadAllProductCategory({ page: 1, limit: 100 }));
		dispatch(loadAllProductSubCategory({ page: 1, limit: 100 }));
		dispatch(loadAllCustomer({ page: 1, limit: 100 }));
		dispatch(loadRunningSize({ page: 1, limit: 1000, status: true }));
	}, [dispatch]);

	const { Title } = Typography;
	const [fileList, setFileList] = useState([]);
	const [loader, setLoader] = useState(false);
	const [isPrinting, setIsPrinting] = useState(false)
	const [isCoating, setIsCoating] = useState(false)
	const [layers, setLayers] = useState([])
	const [layerSelector, setLayerSelector] = useState(false)
	const [gsm, setGsm] = useState([])
	const [bf, setBf] = useState([])
	const [printing, setPrinting] = useState({})
	const [coating, setCoating] = useState({coatings: []})
	const [rateType, setRateType] = useState('individual')

	const [form] = Form.useForm();

	const onFinish = async (values) => {
		console.log("The values on submit", values);
		try {
			let formData = new FormData();
			//formData.append("image", fileList?.[0]?.originFileObj);
			formData.append("name", values.name);
			formData.append("subcategory", values.subcategory);
			formData.append("customer", values.customer);
			formData.append("length", values.length);
			formData.append("width", values.width);
			formData.append("height", values.height);
			formData.append("unitType", values.unitType);
			formData.append("casting", values.casting);
			formData.append("quantity", values.quantity);
			formData.append("lastSalePrice", values.lastSalePrice);
			formData.append("ply", values.ply);
			formData.append("layerSelector", layerSelector);
			formData.append("layers", JSON.stringify(layers));
			formData.append("isPrinting", isPrinting);
			formData.append("printing", JSON.stringify(printing));
			formData.append("isCoating", isCoating);
			formData.append("coating", JSON.stringify(coating));
			if (values.topConversionRate) formData.append("topConversionRate", values.topConversionRate);
			if (values.boxConversionRate) formData.append("boxConversionRate", values.boxConversionRate);
			if (values.rs) formData.append("rs", values.rs);
			if (values.cs) formData.append("cs", values.cs);
			if (values.boxesPerSheet) formData.append("boxesPerSheet", values.boxesPerSheet);
			if (values.sheetsPerBox) formData.append("sheetsPerBox", values.sheetsPerBox);
			if (values.remarks) formData.append("remarks", values.remarks);
			if (values.boxType) formData.append("boxType", values.boxType);
			formData.append("rateType", values.rateType || 'individual');
			if (values.rateType && values.rateType !== 'individual' && values.packingQuantity) {
				formData.append("packingQuantity", values.packingQuantity);
			}
			if (values.joiningMethod) formData.append("joiningMethod", values.joiningMethod);
			
			console.log(formData)
			const resp = await dispatch(addRunningSize(formData));

			if (resp.message === "success") {
				form.resetFields();
				setFileList([]);
				setLoader(false);
			} else {
				setLoader(false);
			}
		} catch (error) {
			console.log("The error occured: ", error.toString());
			toast.error(`error at creating: ${error.message}`);
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		setLoader(false);
		const firstError = errorInfo?.errorFields?.[0]?.errors?.[0] || 'Please fill all required fields';
		toast.error(firstError);
		console.log("Failed:", errorInfo);
	};

	const handelChange = ({ fileList }) => {
		setFileList(fileList);
	};

	const onClickLoading = () => {
		setLoader(true);
	};

	const [cloneLoading, setCloneLoading] = useState(false);

	const handleClone = async (runningSizeId) => {
		if (!runningSizeId) {
			form.resetFields();
			setLayers([]);
			setGsm([]);
			setBf([]);
			setPrinting({});
			setCoating({ coatings: [] });
			setIsPrinting(false);
			setIsCoating(false);
			setLayerSelector(false);
			setRateType('individual');
			return;
		}
		try {
			setCloneLoading(true);
			const { data: rs } = await axios.get(`running-size/${runningSizeId}`);

			// Parse JSON fields
			const parsedLayers = rs.layers ? JSON.parse(rs.layers) : [];
			const parsedPrinting = rs.printing ? JSON.parse(rs.printing) : {};
			const parsedCoating = rs.coating ? JSON.parse(rs.coating) : { coatings: [] };

			// Set component states
			setLayers(parsedLayers);
			setLayerSelector(rs.layer_selector || false);
			setIsPrinting(rs.is_printing || false);
			setPrinting(parsedPrinting);
			setIsCoating(rs.is_coating || false);
			setCoating(parsedCoating);
			setRateType(rs.rate_type || 'individual');

			// Init gsm/bf arrays for layers
			const gsmArr = [];
			const bfArr = [];
			parsedLayers.forEach((layer) => {
				gsmArr.push(layer.materialType ? (data.materialGsm[layer.materialType] || []) : []);
				bfArr.push(layer.materialType ? (data.materialBf[layer.materialType] || []) : []);
			});
			setGsm(gsmArr);
			setBf(bfArr);

			// Build layer form fields
			const layerFields = {};
			if (parsedLayers.length >= 1) {
				layerFields.materialType = parsedLayers[0].materialType;
				layerFields.top_gsm = parsedLayers[0].gsm;
				layerFields['top-bf'] = parsedLayers[0].bf;
			}
			if (parsedLayers.length >= 2) {
				layerFields.flute_materialType = parsedLayers[1].materialType;
				layerFields.flute_gsm = parsedLayers[1].gsm;
				layerFields.flute_bf = parsedLayers[1].bf;
				layerFields.flute_ff = parsedLayers[1].ff;
			}
			if (parsedLayers.length >= 3) {
				layerFields.face_materialType = parsedLayers[2].materialType;
				layerFields.face_gsm = parsedLayers[2].gsm;
				layerFields.face_bf = parsedLayers[2].bf;
			}
			parsedLayers.forEach((layer, i) => {
				if (layer.materialType) layerFields[`materialType-${i}`] = layer.materialType;
				if (layer.gsm) layerFields[`materialGsm-${i}`] = layer.gsm;
				if (layer.bf) layerFields[`materialBf-${i}`] = layer.bf;
				if (layer.ff) layerFields[`materialFf-${i}`] = layer.ff;
			});

			// Build printing form fields
			const printFields = {};
			if (parsedPrinting.printingType) printFields.printing_type = parsedPrinting.printingType;
			if (parsedPrinting.printingColors) printFields.printing_colors = parsedPrinting.printingColors;
			if (parsedPrinting.printingSides) printFields.printing_sides = parsedPrinting.printingSides;
			if (parsedPrinting.printingSpecialColors) printFields.printing_special_colors = parsedPrinting.printingSpecialColors;

			// Build coating form fields
			const coatFields = {};
			if (parsedCoating.coatings && parsedCoating.coatings.length > 0) {
				coatFields.coating_type = parsedCoating.coatings;
			}

			form.setFieldsValue({
				name: '', // blank — user must set a new name
				subcategory: rs.product_sub_category_id,
				customer: rs.customer_id,
				length: rs.length,
				width: rs.width,
				height: rs.height,
				unitType: rs.unit_type,
				casting: rs.casting_type,
				quantity: rs.avg_order_quantity,
				lastSalePrice: rs.last_sale_price,
				ply: rs.ply,
				layerSelector: rs.layer_selector ? 'advance' : 'basic',
				print_selector: rs.is_printing ? 'yes' : 'no',
				isCoating: rs.is_coating ? 'yes' : 'no',
				topConversionRate: rs.top_conversion_rate,
				boxConversionRate: rs.box_conversion_rate,
				rs: rs.rs,
				cs: rs.cs,
				boxesPerSheet: rs.boxes_per_sheet,
				sheetsPerBox: rs.sheets_per_box,
				remarks: rs.remarks || '',
				boxType: rs.box_type || undefined,
				rateType: rs.rate_type || 'individual',
				packingQuantity: rs.packing_quantity || undefined,
				joiningMethod: rs.joining_method || undefined,
				...layerFields,
				...printFields,
				...coatFields,
			});

			toast.success('Running size cloned! Change the Name and any other fields, then save.');
		} catch (error) {
			toast.error('Failed to clone running size');
			console.log(error.message);
		} finally {
			setCloneLoading(false);
		}
	};

	const handlePrintingChange = (e) => {
		if(e.target.value === 'yes'){
			setIsPrinting(true)
		}else{
			setIsPrinting(false)
			setPrinting({})
		}
	}

	const handleCoatingChange = (e) => {
		if(e.target.value === 'yes'){
			setIsCoating(true)
		}else{
			setIsCoating(false)
			setCoating({coatings: []})
		}
	}

	const handlePlyChange = (ply) => {
		const { layersArray, gsmArray, bfArray } = buildLayersForPly(ply, layers, layerObj);
		setLayers(layersArray);
		setGsm(gsmArray);
		setBf(bfArray);
	}

	const handleSelectorChange = (e) => {
		if(e.target.value === 'advance'){
			setLayerSelector(true)
		}else{
			setLayerSelector(false)
		}
	}



	return (
		// <Fragment>
		// 	<Row className='mr-top' justify='space-between' gutter={[0, 30]}>
		// 		<Col
		// 			xs={24}
		// 			sm={24}
		// 			md={24}
		// 			lg={11}
		// 			xl={11}
		// 			className='rounded column-design'>
		// 			<Card bordered={false}>
		// 				<Title level={4} className='m-2 text-center'>
		// 					Add Running Size
		// 				</Title>
		// 				<Form
		// 					form={form}
		// 					name='basic'
		// 					labelCol={{
		// 						span: 7,
		// 					}}
		// 					labelWrap
		// 					wrapperCol={{
		// 						span: 16,
		// 					}}
		// 					initialValues={{
		// 						remember: true,
		// 					}}
		// 					onFinish={onFinish}
		// 					onFinishFailed={onFinishFailed}
		// 					autoComplete='off'>
		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						label='Name'
		// 						name='name'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please input Product name!",
		// 							},
		// 						]}>
		// 						<Input />
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						name='product_sub_category_id'
		// 						label='Subcategory '
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please select sub-category!",
		// 							},
		// 						]}>
		// 						<Select
		// 							name='product_sub_category_id'
		// 							loading={!subCategory}
		// 							showSearch
		// 							placeholder='Select Subcategory'
		// 							optionFilterProp='children'
		// 							filterOption={(input, option) =>
		// 								option.children.includes(input)
		// 							}
		// 							filterSort={(optionA, optionB) =>
		// 								optionA.children
		// 									.toLowerCase()
		// 									.localeCompare(optionB.children.toLowerCase())
		// 							}>
		// 							{subCategory &&
		// 								subCategory.map((subcat) => (
		// 									<Select.Option key={subcat.id} value={subcat.id}>
		// 										{subcat.name}
		// 									</Select.Option>
		// 								))}
		// 						</Select>
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						name='customer'
		// 						label='Customer'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please select customer!",
		// 							},
		// 						]}>
		// 						<Select
		// 							name='customer'
		// 							loading={!customer}
		// 							showSearch
		// 							placeholder='Select Customer'
		// 							optionFilterProp='children'
		// 							filterOption={(input, option) =>
		// 								option.children.includes(input)
		// 							}
		// 							filterSort={(optionA, optionB) =>
		// 								optionA.children
		// 									.toLowerCase()
		// 									.localeCompare(optionB.children.toLowerCase())
		// 							}>
		// 							{customer &&
		// 								customer.map((cust) => (
		// 									<Select.Option key={cust.id} value={cust.id}>
		// 										{cust.name}
		// 									</Select.Option>
		// 								))}
		// 						</Select>
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						label='Length'
		// 						name='length'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please input length!",
		// 							},
		// 						]}>
		// 						<Input type='number' />
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						label='Width'
		// 						name='width'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please input width!",
		// 							},
		// 						]}>
		// 						<Input type='number' />
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						label='Height'
		// 						name='height'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please input height!",
		// 							},
		// 						]}>
		// 						<Input type='number' />
		// 					</Form.Item>


		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						name='unit_type'
		// 						label='Unit'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please select unit type!",
		// 							},
		// 						]}>
		// 						<Select
		// 							name='unit_type'
		// 							loading={!category}
		// 							showSearch
		// 							placeholder='Unit'
		// 							optionFilterProp='children'
		// 							filterOption={(input, option) =>
		// 								option.children.includes(input)
		// 							}
		// 							filterSort={(optionA, optionB) =>
		// 								optionA.children
		// 									.toLowerCase()
		// 									.localeCompare(optionB.children.toLowerCase())
		// 							}>
		// 							{unitType &&
		// 								unitType.map((unit) => (
		// 									<Select.Option key={unit} value={unit}>
		// 										{unit}
		// 									</Select.Option>
		// 								))}
		// 						</Select>
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						name='ply'
		// 						label='Ply/ Walls'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please select plys!",
		// 							},
		// 						]}>
		// 						<Select
		// 							name='ply'
		// 							loading={!category}
		// 							showSearch
		// 							placeholder='Ply/ Walls'
		// 							optionFilterProp='children'
		// 							filterOption={(input, option) =>
		// 								option.children.includes(input)
		// 							}
		// 							filterSort={(optionA, optionB) =>
		// 								optionA.children
		// 									.toLowerCase()
		// 									.localeCompare(optionB.children.toLowerCase())
		// 							}>
		// 							{ply &&
		// 								ply.map((ply) => (
		// 									<Select.Option key={ply.value} value={ply.value}>
		// 										{ply.name}
		// 									</Select.Option>
		// 								))}
		// 						</Select>
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						name='casting'
		// 						label='Casting'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please select casting!",
		// 							},
		// 						]}>
		// 						<Select
		// 							name='casting'
		// 							loading={!category}
		// 							showSearch
		// 							placeholder='Casting'
		// 							optionFilterProp='children'
		// 							filterOption={(input, option) =>
		// 								option.children.includes(input)
		// 							}
		// 							filterSort={(optionA, optionB) =>
		// 								optionA.children
		// 									.toLowerCase()
		// 									.localeCompare(optionB.children.toLowerCase())
		// 							}>
		// 							{unitType &&
		// 								unitType.map((unit) => (
		// 									<Select.Option key={unit} value={unit}>
		// 										{unit}
		// 									</Select.Option>
		// 								))}
		// 						</Select>
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						label='Quantity'
		// 						name='quantity'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please input Quantity!",
		// 							},
		// 						]}>
		// 						<Input type='number' />
		// 					</Form.Item>


		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						label='Sale Price'
		// 						name='sale_price'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please input Sale Price!",
		// 							},
		// 						]}>
		// 						<Input type='number' />
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						name='printing'
		// 						label='Printing'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please select printing!",
		// 							},
		// 						]}>
		// 						<Select
		// 							name='printing'
		// 							loading={!category}
		// 							showSearch
		// 							placeholder='Printing'
		// 							optionFilterProp='children'
		// 							filterOption={(input, option) =>
		// 								option.children.includes(input)
		// 							}
		// 							filterSort={(optionA, optionB) =>
		// 								optionA.children
		// 									.toLowerCase()
		// 									.localeCompare(optionB.children.toLowerCase())
		// 							}>
		// 							{unitType &&
		// 								unitType.map((unit) => (
		// 									<Select.Option key={unit} value={unit}>
		// 										{unit}
		// 									</Select.Option>
		// 								))}
		// 						</Select>
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						name='coating'
		// 						label='Coating'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please select coating type!",
		// 							},
		// 						]}>
		// 						<Select
		// 							name='coating'
		// 							loading={!category}
		// 							showSearch
		// 							placeholder='Coating Type'
		// 							optionFilterProp='children'
		// 							filterOption={(input, option) =>
		// 								option.children.includes(input)
		// 							}
		// 							filterSort={(optionA, optionB) =>
		// 								optionA.children
		// 									.toLowerCase()
		// 									.localeCompare(optionB.children.toLowerCase())
		// 							}>
		// 							{unitType &&
		// 								unitType.map((unit) => (
		// 									<Select.Option key={unit} value={unit}>
		// 										{unit}
		// 									</Select.Option>
		// 								))}
		// 						</Select>
		// 					</Form.Item>

							

		// 					{/* <Form.Item label='Upload Image' valuePropName='image'>
		// 						<Upload
		// 							listType='picture-card'
		// 							beforeUpload={() => false}
		// 							name='image'
		// 							fileList={fileList}
		// 							maxCount={1}
		// 							onChange={handelChange}>
		// 							<div>
		// 								<PlusOutlined />
		// 								<div
		// 									style={{
		// 										marginTop: 8,
		// 									}}>
		// 									Upload
		// 								</div>
		// 							</div>
		// 						</Upload>
		// 					</Form.Item> */}

							

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						className={styles.addProductBtnContainer}>
		// 						<Button
		// 							type='primary'
		// 							htmlType='submit'
		// 							shape='round'
		// 							loading={loader}
		// 							onClick={onClickLoading}>
		// 							Add Running Size
		// 						</Button>
		// 					</Form.Item>
		// 				</Form>
		// 			</Card>
		// 		</Col>
		// 		<Col
		// 			xs={24}
		// 			sm={24}
		// 			md={24}
		// 			lg={11}
		// 			xl={11}
		// 			className='rounded column-design'>
		// 			<Card bordered={false}>
		// 				<Title level={4} className='m-2 text-center'>
		// 					Add Customization
		// 				</Title>
		// 				<Form
		// 					form={form}
		// 					name='basic'
		// 					labelCol={{
		// 						span: 7,
		// 					}}
		// 					labelWrap
		// 					wrapperCol={{
		// 						span: 16,
		// 					}}
		// 					initialValues={{
		// 						remember: true,
		// 					}}
		// 					onFinish={onFinish}
		// 					onFinishFailed={onFinishFailed}
		// 					autoComplete='off'>
		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						label='Name'
		// 						name='name'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please input Product name!",
		// 							},
		// 						]}>
		// 						<Input />
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						name='product_sub_category_id'
		// 						label='Subcategory '
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please select sub-category!",
		// 							},
		// 						]}>
		// 						<Select
		// 							name='product_sub_category_id'
		// 							loading={!subCategory}
		// 							showSearch
		// 							placeholder='Select Subcategory'
		// 							optionFilterProp='children'
		// 							filterOption={(input, option) =>
		// 								option.children.includes(input)
		// 							}
		// 							filterSort={(optionA, optionB) =>
		// 								optionA.children
		// 									.toLowerCase()
		// 									.localeCompare(optionB.children.toLowerCase())
		// 							}>
		// 							{subCategory &&
		// 								subCategory.map((subcat) => (
		// 									<Select.Option key={subcat.id} value={subcat.id}>
		// 										{subcat.name}
		// 									</Select.Option>
		// 								))}
		// 						</Select>
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						name='customer'
		// 						label='Customer'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please select customer!",
		// 							},
		// 						]}>
		// 						<Select
		// 							name='customer'
		// 							loading={!customer}
		// 							showSearch
		// 							placeholder='Select Customer'
		// 							optionFilterProp='children'
		// 							filterOption={(input, option) =>
		// 								option.children.includes(input)
		// 							}
		// 							filterSort={(optionA, optionB) =>
		// 								optionA.children
		// 									.toLowerCase()
		// 									.localeCompare(optionB.children.toLowerCase())
		// 							}>
		// 							{customer &&
		// 								customer.map((cust) => (
		// 									<Select.Option key={cust.id} value={cust.id}>
		// 										{cust.name}
		// 									</Select.Option>
		// 								))}
		// 						</Select>
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						label='Length'
		// 						name='length'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please input length!",
		// 							},
		// 						]}>
		// 						<Input type='number' />
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						label='Width'
		// 						name='width'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please input width!",
		// 							},
		// 						]}>
		// 						<Input type='number' />
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						label='Height'
		// 						name='height'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please input height!",
		// 							},
		// 						]}>
		// 						<Input type='number' />
		// 					</Form.Item>


		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						name='unit_type'
		// 						label='Unit'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please select unit type!",
		// 							},
		// 						]}>
		// 						<Select
		// 							name='unit_type'
		// 							loading={!category}
		// 							showSearch
		// 							placeholder='Unit'
		// 							optionFilterProp='children'
		// 							filterOption={(input, option) =>
		// 								option.children.includes(input)
		// 							}
		// 							filterSort={(optionA, optionB) =>
		// 								optionA.children
		// 									.toLowerCase()
		// 									.localeCompare(optionB.children.toLowerCase())
		// 							}>
		// 							{unitType &&
		// 								unitType.map((unit) => (
		// 									<Select.Option key={unit} value={unit}>
		// 										{unit}
		// 									</Select.Option>
		// 								))}
		// 						</Select>
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						name='ply'
		// 						label='Ply/ Walls'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please select plys!",
		// 							},
		// 						]}>
		// 						<Select
		// 							name='ply'
		// 							loading={!category}
		// 							showSearch
		// 							placeholder='Ply/ Walls'
		// 							optionFilterProp='children'
		// 							filterOption={(input, option) =>
		// 								option.children.includes(input)
		// 							}
		// 							filterSort={(optionA, optionB) =>
		// 								optionA.children
		// 									.toLowerCase()
		// 									.localeCompare(optionB.children.toLowerCase())
		// 							}>
		// 							{ply &&
		// 								ply.map((ply) => (
		// 									<Select.Option key={ply.value} value={ply.value}>
		// 										{ply.name}
		// 									</Select.Option>
		// 								))}
		// 						</Select>
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						name='casting'
		// 						label='Casting'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please select casting!",
		// 							},
		// 						]}>
		// 						<Select
		// 							name='casting'
		// 							loading={!category}
		// 							showSearch
		// 							placeholder='Casting'
		// 							optionFilterProp='children'
		// 							filterOption={(input, option) =>
		// 								option.children.includes(input)
		// 							}
		// 							filterSort={(optionA, optionB) =>
		// 								optionA.children
		// 									.toLowerCase()
		// 									.localeCompare(optionB.children.toLowerCase())
		// 							}>
		// 							{unitType &&
		// 								unitType.map((unit) => (
		// 									<Select.Option key={unit} value={unit}>
		// 										{unit}
		// 									</Select.Option>
		// 								))}
		// 						</Select>
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						label='Quantity'
		// 						name='quantity'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please input Quantity!",
		// 							},
		// 						]}>
		// 						<Input type='number' />
		// 					</Form.Item>


		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						label='Sale Price'
		// 						name='sale_price'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please input Sale Price!",
		// 							},
		// 						]}>
		// 						<Input type='number' />
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						name='printing'
		// 						label='Printing'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please select printing!",
		// 							},
		// 						]}>
		// 						<Select
		// 							name='printing'
		// 							loading={!category}
		// 							showSearch
		// 							placeholder='Printing'
		// 							optionFilterProp='children'
		// 							filterOption={(input, option) =>
		// 								option.children.includes(input)
		// 							}
		// 							filterSort={(optionA, optionB) =>
		// 								optionA.children
		// 									.toLowerCase()
		// 									.localeCompare(optionB.children.toLowerCase())
		// 							}>
		// 							{unitType &&
		// 								unitType.map((unit) => (
		// 									<Select.Option key={unit} value={unit}>
		// 										{unit}
		// 									</Select.Option>
		// 								))}
		// 						</Select>
		// 					</Form.Item>

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						name='coating'
		// 						label='Coating'
		// 						rules={[
		// 							{
		// 								required: true,
		// 								message: "Please select coating type!",
		// 							},
		// 						]}>
		// 						<Select
		// 							name='coating'
		// 							loading={!category}
		// 							showSearch
		// 							placeholder='Coating Type'
		// 							optionFilterProp='children'
		// 							filterOption={(input, option) =>
		// 								option.children.includes(input)
		// 							}
		// 							filterSort={(optionA, optionB) =>
		// 								optionA.children
		// 									.toLowerCase()
		// 									.localeCompare(optionB.children.toLowerCase())
		// 							}>
		// 							{unitType &&
		// 								unitType.map((unit) => (
		// 									<Select.Option key={unit} value={unit}>
		// 										{unit}
		// 									</Select.Option>
		// 								))}
		// 						</Select>
		// 					</Form.Item>

							

		// 					{/* <Form.Item label='Upload Image' valuePropName='image'>
		// 						<Upload
		// 							listType='picture-card'
		// 							beforeUpload={() => false}
		// 							name='image'
		// 							fileList={fileList}
		// 							maxCount={1}
		// 							onChange={handelChange}>
		// 							<div>
		// 								<PlusOutlined />
		// 								<div
		// 									style={{
		// 										marginTop: 8,
		// 									}}>
		// 									Upload
		// 								</div>
		// 							</div>
		// 						</Upload>
		// 					</Form.Item> */}

							

		// 					<Form.Item
		// 						style={{ marginBottom: "15px" }}
		// 						className={styles.addProductBtnContainer}>
		// 						<Button
		// 							type='primary'
		// 							htmlType='submit'
		// 							shape='round'
		// 							loading={loader}
		// 							onClick={onClickLoading}>
		// 							Add Running Size
		// 						</Button>
		// 					</Form.Item>
		// 				</Form>
		// 			</Card>
		// 		</Col>
		// 		<Col xs={24} sm={24} md={24} lg={11} xl={11} className=' rounded'>
		// 			<Card className={`${styles.importCsvCard} column-design`}>
		// 				<Title level={4} className='m-2 text-center'>
		// 					Import From CSV
		// 				</Title>
		// 				<UploadMany urlPath={"product"} />
		// 			</Card>
		// 		</Col>
		// 	</Row>
		// </Fragment>

	<Fragment>
		<Row className='mr-top' justify='space-between' gutter={[0, 30]}>
			<Col
				xs={24}
				sm={24}
				md={24}
				lg={24}
				xl={24}
				className='rounded column-design'
			>
				
				<Form
					form={form}
					name='basic'
					labelCol={{
						span: 7,
					}}
					labelWrap
					wrapperCol={{
						span: 16,
					}}
					initialValues={{
						remember: true,
						layerSelector: 'basic',
						print_selector: 'no',
						isCoating: 'no',
						// Inches is the system-wide convention for Indian corrugated box dimensions
						// (see poIngest.controllers.js's PO_JSON_SCHEMA) — without an explicit default
						// here, alphabetical Select ordering put "cm" first, which operators quickly
						// tabbing through the form could pick unintentionally.
						unitType: 'inches',
					}}
					onFinish={onFinish}
					onFinishFailed={onFinishFailed}
					autoComplete='off'
				>
					<Row className='mr-top' justify='space-evenly' gutter={[0, 30]}>
			<Col
				xs={24}
				sm={24}
				md={24}
				lg={10}
				xl={10}
				className='rounded column-design'
			>
				<Card bordered={false}>
				<Title level={4} className='m-2 text-center'>
					Sizing
				</Title>

				<div style={{ marginBottom: 20, padding: '12px 16px', background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 8 }}>
					<Typography.Text strong style={{ display: 'block', marginBottom: 8 }}>Clone from Existing Running Size</Typography.Text>
					<Select
						showSearch
						allowClear
						loading={cloneLoading}
						placeholder='Select a running size to clone...'
						optionFilterProp='children'
						filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
						style={{ width: '100%' }}
						onChange={handleClone}
					>
						{runningSizes && Array.isArray(runningSizes) && runningSizes.map((rs) => (
							<Select.Option key={rs.id} value={rs.id}>
								{rs.name}
							</Select.Option>
						))}
					</Select>
				</div>
			
				<Form.Item
						style={{ marginBottom: "15px" }}
						label='Name'
						name='name'
					rules={[
						{
							required: true,
							message: "Please input Product name!",
						},
					]}>
					<Input />
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					name='subcategory'
					label='Subcategory '
					rules={[
						{
							required: true,
							message: "Please select sub-category!",
						},
					]}>
					<Select
						name='subcategory'
						loading={!subCategory}
						showSearch
						placeholder='Select Subcategory'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						filterSort={(optionA, optionB) =>
							optionA?.children
								.toLowerCase()
								.localeCompare(optionB?.children.toLowerCase())
						}>
						{subCategory &&
							subCategory.map((subcat) => (
								<Select.Option key={subcat.id} value={subcat.id}>
									{subcat.name}
								</Select.Option>
							))}
					</Select>
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					name='customer'
					label='Customer'
					rules={[
						{
							required: true,
							message: "Please select customer!",
						},
					]}>
					<Select
						name='customer'
						loading={!customer}
						showSearch
						placeholder='Select Customer'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						filterSort={(optionA, optionB) =>
							optionA?.children
								.toLowerCase()
								.localeCompare(optionB?.children.toLowerCase())
						}>
						{customer &&
							customer.map((cust) => (
								<Select.Option key={cust.id} value={cust.id}>
									{cust.name}
								</Select.Option>
							))}
					</Select>
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Length'
					name='length'
					rules={[
						{
							required: true,
							message: "Please input length!",
						},
					]}>
					<Input type='number' />
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Width'
					name='width'
					rules={[
						{
							required: true,
							message: "Please input width!",
						},
					]}>
					<Input type='number' />
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Height'
					name='height'
					rules={[
						{
							required: true,
							message: "Please input height!",
						},
					]}>
					<Input type='number' />
				</Form.Item>


				<Form.Item
					style={{ marginBottom: "15px" }}
					name='unitType'
					label='Unit'
					rules={[
						{
							required: true,
							message: "Please select unit type!",
						},
					]}>
					<Select
						name='unitType'
						loading={!unitType}
						showSearch
						placeholder='Unit'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}>
						{unitType &&
							unitType.map((unit) => (
								<Select.Option key={unit} value={unit}>
									{unit}
								</Select.Option>
							))}
					</Select>
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					name='casting'
					label='Casting'
					rules={[
						{
							required: true,
							message: "Please select casting!",
						},
					]}>
					<Select
						name='casting'
						loading={!castingType}
						showSearch
						placeholder='Casting'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option?.children.includes(input)
						}>
						{castingType &&
							castingType.map((casting, i) => (
								<Select.Option key={i+1} value={casting.value}>
									{casting.name}
								</Select.Option>
							))}
					</Select>
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Quantity'
					name='quantity'
					rules={[
						{
							required: true,
							message: "Please input Quantity!",
						},
					]}>
					<Input type='number' />
				</Form.Item>


				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Sale Price'
					name='lastSalePrice'
					rules={[
						{
							required: true,
							message: "Please input Sale Price!",
						},
					]}
					>
					<Input type='number' />
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Top Conversion Rate /Kg'
					name='topConversionRate'
					rules={[
						{
							required: true,
							message: "Please input top conversion rate!",
						},
					]}
					>
					<Input type='number' />
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Box Conversion Rate /Kg'
					name='boxConversionRate'
					rules={[
						{
							required: true,
							message: "Please input box conversion rate!",
						},
					]}
					>
					<Input type='number' />
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='RS'
					name='rs'
				>
					<Input type='number' placeholder='Optional' />
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='CS'
					name='cs'
				>
					<Input type='number' placeholder='Optional' />
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Boxes per Sheet (m)'
					name='boxesPerSheet'
				>
					<Input type='number' min={1} placeholder='Optional' />
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Sheets per Box (n)'
					name='sheetsPerBox'
				>
					<Input type='number' min={1} placeholder='Optional' />
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Remarks'
					name='remarks'
				>
					<Input.TextArea rows={2} placeholder='Optional remarks' />
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					name='boxType'
					label='Box Type'
				>
					<Select placeholder='Select Box Type' allowClear>
						<Select.Option value='inner'>Inner</Select.Option>
						<Select.Option value='outer'>Outer</Select.Option>
					</Select>
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					name='rateType'
					label='Rate Type'
					initialValue='individual'
				>
					<Select placeholder='Select Rate Type' onChange={(val) => setRateType(val)}>
						<Select.Option value='individual'>Individual</Select.Option>
						<Select.Option value='innerwise'>Innerwise</Select.Option>
						<Select.Option value='outerwise'>Outerwise</Select.Option>
					</Select>
				</Form.Item>

				{rateType && rateType !== 'individual' && (
					<Form.Item
						style={{ marginBottom: "15px" }}
						label='No. of Inners'
						name='packingQuantity'
						rules={[{ required: true, message: 'Please input no. of inners!' }]}
					>
						<Input type='number' min={1} placeholder='No. of inners per outer' />
					</Form.Item>
				)}

				<Form.Item
					style={{ marginBottom: "15px" }}
					name='joiningMethod'
					label='Glueing'
				>
					<Radio.Group buttonStyle='solid'>
						<Radio.Button value='stitching'>Stitching</Radio.Button>
						<Radio.Button value='hand_pasting'>Hand Pasting</Radio.Button>
					</Radio.Group>
				</Form.Item>

				{/*<Form.Item label='Upload Image' valuePropName='image'>
					<Upload
						listType='picture-card'
						beforeUpload={() => false}
						name='image'
						fileList={fileList}
						maxCount={1}
						onChange={handelChange}>
						<div>
							<PlusOutlined />
							<div
								style={{
									marginTop: 8,
								}}>
								Upload
							</div>
						</div>
					</Upload>
				</Form.Item> */}
			
				</Card>
			</Col>
			
			
			<Col
				xs={24}
				sm={24}
				md={24}
				lg={14}
				xl={14}
				className='rounded column-design'
			>
		<Card bordered={false}>
			<Title level={4} className='m-2 text-center'>
				Customization
			</Title>
			
				<Form.Item
					style={{ marginBottom: "15px" }}
					name='ply'
					label='Ply/ Walls'
					rules={[
						{
							required: true,
							message: "Please select plys!",
						},
					]}>
					<Select
						name='ply'
						loading={!category}
						showSearch
						placeholder='Ply/ Walls'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						filterSort={(optionA, optionB) =>
							optionA?.children
								.toLowerCase()
								.localeCompare(optionB?.children.toLowerCase())
						}
						onChange={handlePlyChange}>
						{ply &&
							ply.map((ply) => (
								<Select.Option key={ply.value} value={ply.value}>
									{ply.name}
								</Select.Option>
							))}
					</Select>
				</Form.Item>

				<LayerTemplateSelector
					ply={layers.length}
					layers={layers}
					setLayers={setLayers}
					gsm={gsm}
					setGsm={setGsm}
					bf={bf}
					setBf={setBf}
				/>

				<Form.Item
					rules={[
						{
							required: true,
							message: "Pleases Select Type!",
						},
					]}
					label='Layer Selector'
					name="layerSelector"
					style={{ marginBottom: "15px" }}
				>
					<Radio.Group onChange={handleSelectorChange}> 
						<Radio value='basic'>Basic</Radio>
						<Radio value='advance'>Advance</Radio>
					</Radio.Group>
				</Form.Item>

				{!layerSelector ? <LayerSelectorBasic layers={layers} setLayers={setLayers} layerSelector={layerSelector}/> : <LayerSelectorAdvance layers={layers} gsm ={gsm} bf={bf} setLayers={setLayers} setGsm={setGsm} setBf={setBf} layerSelector={layerSelector}/>}
				
				<Form.Item
					// rules={[
					// 	{
					// 		required: true,
					// 		message: "Pleases Select If Printing Required!",
					// 	},
					// ]}
					label='Printing'
					name={"print_selector"}
					style={{ marginBottom: "15px" }}
				>
					<Radio.Group onChange={e => handlePrintingChange(e)}>
						<Radio value='yes'>Yes</Radio>
						<Radio value='no'>No</Radio>
					</Radio.Group>
				</Form.Item>
				
				{isPrinting? <PrintSelector printing={printing} setPrinting={setPrinting} isPrinting={isPrinting} />: <></> }
				
				

				<Form.Item
					// rules={[
					// 	{
					// 		required: true,
					// 		message: "Please Select Coating!",
					// 	},
					// ]}
					label='Coating'
					name={"isCoating"}
					style={{ marginBottom: "15px" }}
				>
					<Radio.Group onChange={handleCoatingChange}>
						<Radio value='yes'>Yes</Radio>
						<Radio value='no'>No</Radio>
					</Radio.Group>
				</Form.Item>

				{isCoating? <CoatingSelector coating={coating} setCoating={setCoating} isCoating={isCoating} /> : <></>}

				
				{/* <Form.Item label='Upload Image' valuePropName='image'>
					<Upload
						listType='picture-card'
						beforeUpload={() => false}
						name='image'
						fileList={fileList}
						maxCount={1}
						onChange={handelChange}>
						<div>
							<PlusOutlined />
							<div
								style={{
									marginTop: 8,
								}}>
								Upload
							</div>
						</div>
					</Upload>
				</Form.Item>  */}

				

				<Form.Item
					style={{ marginBottom: "15px" }}
					className={styles.addProductBtnContainer}>
					<Button
						type='primary'
						htmlType='submit'
						shape='round'
						loading={loader}
						onClick={onClickLoading}>
						Add Running Size
					</Button>
				</Form.Item>
			</Card>
			</Col>
		
		
		
		 {/* <Col xs={24} sm={24} md={24} lg={11} xl={11} className=' rounded'>
			<Card className={`${styles.importCsvCard} column-design`}>
				<Title level={4} className='m-2 text-center'>
					Import From CSV
				</Title>
				<UploadMany urlPath={"product"} />
			</Card>
		</Col> */}
					</Row>
				</Form>
				
			</Col>
		</Row>
	</Fragment>
	);
};

export default AddRunningSize;
